var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 8.00008C0.667969 3.94999 3.95121 0.666748 8.0013 0.666748C12.0514 0.666748 15.3346 3.94999 15.3346 8.00008C15.3346 12.0502 12.0514 15.3334 8.0013 15.3334C3.95121 15.3334 0.667969 12.0502 0.667969 8.00008ZM8.0013 2.00008C4.68759 2.00008 2.0013 4.68637 2.0013 8.00008C2.0013 11.3138 4.68759 14.0001 8.0013 14.0001C11.315 14.0001 14.0013 11.3138 14.0013 8.00008C14.0013 4.68637 11.315 2.00008 8.0013 2.00008Z",
    fill: "#91919D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.87f17488f5a5ea70721ad94f17d0118f.svg";
export { ForwardRef as ReactComponent };